<div
  *ngIf="services.room_fees_description"
  [ngClass]="{
    'col-6': services.room_fees_description && services.mandatory_fees_description,
    'col-12': services.room_fees_description && !services.mandatory_fees_description,
  }"
  class="mb-col-12--tb mb-col-12--ph block-container"
>
  <mb-icon-text>
    <mb-icon icon="room-service"></mb-icon>
    <span class="title" i18n="@@services_servicios_opcionales_de_habitacion"
      >Servicios opcionales de habitación</span
    >
  </mb-icon-text>
  <span>{{ services.room_fees_description }}</span>
</div>
<div
  *ngIf="services.mandatory_fees_description"
  [ngClass]="{
    'col-6': services.room_fees_description && services.mandatory_fees_description,
    'col-12': !services.room_fees_description && services.mandatory_fees_description,
  }"
  class="mb-col-12--tb mb-col-12--ph block-container"
>
  <mb-icon-text>
    <mb-icon icon="services"></mb-icon>
    <span class="title" i18n="@@services_servicios_incluidos_en_la_reserva"
      >Servicios incluidos en la reserva</span
    >
  </mb-icon-text>
  <span>{{ services.mandatory_fees_description }}</span>
</div>
